export var AddressRepeatedAction;
(function (AddressRepeatedAction) {
    AddressRepeatedAction["OVERRIDE"] = "OVERRIDE";
    AddressRepeatedAction["DISCARD"] = "DISCARD";
    AddressRepeatedAction["APPEND"] = "APPEND";
})(AddressRepeatedAction || (AddressRepeatedAction = {}));
export var AddressRepeatedActionName;
(function (AddressRepeatedActionName) {
    AddressRepeatedActionName["OVERRIDE"] = "\u4EE5\u65B0\u8054\u7CFB\u4EBA\u4E3A\u51C6";
    AddressRepeatedActionName["DISCARD"] = "\u4EE5\u5386\u53F2\u8054\u7CFB\u4EBA\u4E3A\u51C6";
    AddressRepeatedActionName["APPEND"] = "\u5408\u5E76";
})(AddressRepeatedActionName || (AddressRepeatedActionName = {}));
export var AddressBookEnumDemo;
(function (AddressBookEnumDemo) {
    AddressBookEnumDemo["X"] = "X";
    AddressBookEnumDemo["Y"] = "Y";
})(AddressBookEnumDemo || (AddressBookEnumDemo = {}));
export var AddressBookContactAddressType;
(function (AddressBookContactAddressType) {
    AddressBookContactAddressType[AddressBookContactAddressType["EMAIL"] = 1] = "EMAIL";
    AddressBookContactAddressType[AddressBookContactAddressType["WHATSAPP"] = 2] = "WHATSAPP";
})(AddressBookContactAddressType || (AddressBookContactAddressType = {}));
export var AddressBookContactSourceType;
(function (AddressBookContactSourceType) {
    AddressBookContactSourceType[AddressBookContactSourceType["\u590D\u5236\u7C98\u8D34"] = 1] = "\u590D\u5236\u7C98\u8D34";
    AddressBookContactSourceType[AddressBookContactSourceType["\u6587\u4EF6\u5BFC\u5165"] = 2] = "\u6587\u4EF6\u5BFC\u5165";
    AddressBookContactSourceType[AddressBookContactSourceType["\u4E2A\u4EBA\u901A\u8BAF\u5F55"] = 101] = "\u4E2A\u4EBA\u901A\u8BAF\u5F55";
    AddressBookContactSourceType[AddressBookContactSourceType["\u5916\u8D38\u901A\u52A9\u624B"] = 102] = "\u5916\u8D38\u901A\u52A9\u624B";
    AddressBookContactSourceType[AddressBookContactSourceType["\u5168\u7403\u641C\u7D22"] = 103] = "\u5168\u7403\u641C\u7D22";
    AddressBookContactSourceType[AddressBookContactSourceType["\u6D77\u5173\u6570\u636E"] = 104] = "\u6D77\u5173\u6570\u636E";
    AddressBookContactSourceType[AddressBookContactSourceType["\u5BA2\u6237\u8054\u7CFB\u4EBA\u540C\u6B65"] = 105] = "\u5BA2\u6237\u8054\u7CFB\u4EBA\u540C\u6B65";
    AddressBookContactSourceType[AddressBookContactSourceType["\u90AE\u4EF6\u8425\u9500\u5BFC\u5165"] = 106] = "\u90AE\u4EF6\u8425\u9500\u5BFC\u5165";
    AddressBookContactSourceType[AddressBookContactSourceType["\u667A\u80FD\u5F15\u64CE\u641C\u7D22"] = 107] = "\u667A\u80FD\u5F15\u64CE\u641C\u7D22";
    AddressBookContactSourceType[AddressBookContactSourceType["\u8425\u9500\u6258\u7BA1"] = 108] = "\u8425\u9500\u6258\u7BA1";
    AddressBookContactSourceType[AddressBookContactSourceType["\u9886\u82F1\u641C\u7D22"] = 109] = "\u9886\u82F1\u641C\u7D22";
    AddressBookContactSourceType[AddressBookContactSourceType["\u667A\u80FD\u63A8\u8350"] = 110] = "\u667A\u80FD\u63A8\u8350";
    AddressBookContactSourceType[AddressBookContactSourceType["\u7EBF\u7D22\u8054\u7CFB\u4EBA\u540C\u6B65"] = 111] = "\u7EBF\u7D22\u8054\u7CFB\u4EBA\u540C\u6B65";
})(AddressBookContactSourceType || (AddressBookContactSourceType = {}));
export var AddressBookGroupType;
(function (AddressBookGroupType) {
    AddressBookGroupType[AddressBookGroupType["SYSTEM"] = 0] = "SYSTEM";
    AddressBookGroupType[AddressBookGroupType["USER"] = 1] = "USER";
})(AddressBookGroupType || (AddressBookGroupType = {}));
export var AddressBookSyncType;
(function (AddressBookSyncType) {
    AddressBookSyncType["CRM"] = "CRM";
})(AddressBookSyncType || (AddressBookSyncType = {}));
